import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { EDocumentType, User } from '@common/core/models';
import { UsersService } from '@common/core/services/api/users.service';
import { EBitfCloseEventStatus } from '@common/enums';
import { EUsersRole } from '@common/enums/users-role.enum';
import { BitfMatSidenavService } from '@common/libs/bitforce/core/services/sidenav/material/bitf-mat-sidenav.service';
import { APP_VERSION } from '@env/version';
import { AuthService, DialogsService, StoreService } from '@web/core/services';
import { eStoreActions } from '@web/enums';
import { PolicyDialogComponent } from '@web/shared/components/policy-dialog/policy-dialog.component';

@Component({
  selector: 'casa-doc-menu',
  templateUrl: './menu.component.html',
  styleUrl: './menu.component.scss',
  standalone: false,
})
export class MenuComponent implements OnInit {
  router = inject(Router);
  route = inject(ActivatedRoute);
  appVersion = APP_VERSION;
  eUsersRole = EUsersRole;
  eDocumentType = EDocumentType;
  infoMail = 'info@casa-doc.it';

  constructor(
    private bitfMatSidenavService: BitfMatSidenavService,
    private authService: AuthService,
    public storeService: StoreService,
    private dialogsService: DialogsService,
    private usersService: UsersService
  ) {}

  ngOnInit(): void {}

  closeSidenav() {
    this.bitfMatSidenavService.close({ status: EBitfCloseEventStatus.CLOSE });
  }

  onSignOut() {
    this.authService.signOut();
  }

  openPrivacyPolicy() {
    this.dialogsService.dialog.open(PolicyDialogComponent, {
      width: '90vw',
      height: '90vh',
      data: {
        policyType: 'privacy',
      },
    });
    this.closeSidenav();
  }

  openCookiePolicy() {
    this.dialogsService.dialog.open(PolicyDialogComponent, {
      width: '90vw',
      height: '90vh',
      data: {
        policyType: 'cookie',
      },
    });
    this.closeSidenav();
  }

  openTermsAndConditions() {
    this.dialogsService.dialog.open(PolicyDialogComponent, {
      width: '90vw',
      height: '90vh',
      data: {
        policyType: EDocumentType.TERMS_AND_CONDITIONS_CASADOC,
      },
    });
    this.closeSidenav();
  }

  openCookiePreferences() {
    const btn = document.getElementsByClassName('lb-cs-settings-link') as HTMLCollectionOf<HTMLElement>;
    btn[0]?.click();
  }

  onPhotoError() {
    this.usersService.getMe().subscribe((response) => {
      if (response.content) {
        this.storeService.setStore((store) => {
          store.user = new User(response.content);
        }, eStoreActions.SET_USER);
      }
    });
  }
}
